import { PureTableRow } from '../../../common/PureTable/PureTable.types';
import { RemoveDownloadItemStateProps } from './DownloadsList.types';
import { DOWNLOADS_LIST_LABELS } from '../../../../lib/constants/labelKeys';
import ScormInlineAction from './ScormInlineAction';
import styles from './DownloadsList.module.scss';
import { Api } from '../../../../lib/types/apiSpec';

export const mapDownloadItemToTableRow =
  <T extends { id: string; trainingId: string; name: string; type: Api.TrainingType }>(
    props: (keyof T)[],
    { onBinClickHandler, itemsRemovingState }: RemoveDownloadItemStateProps,
  ) =>
  (acc: Record<string, PureTableRow>, curr: T): Record<string, PureTableRow> => {
    return {
      ...acc,
      [curr.id]: [
        <span key={`${curr.id}|${curr[props[0]]}`} className={styles.tableRow}>
          <span>{props.map(prop => curr[prop] as string).join()}</span>
          <ScormInlineAction
            id={curr.id}
            name={curr.name}
            type={curr.type}
            labelKeys={DOWNLOADS_LIST_LABELS}
            onConfirm={onBinClickHandler}
            isRemoving={itemsRemovingState?.[curr.trainingId]}
          />
        </span>,
      ],
    };
  };
